import { render, staticRenderFns } from "./ArtikelEdit.vue?vue&type=template&id=af851364&scoped=true"
import script from "./ArtikelEdit.vue?vue&type=script&lang=ts"
export * from "./ArtikelEdit.vue?vue&type=script&lang=ts"
import style0 from "./ArtikelEdit.vue?vue&type=style&index=0&id=af851364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af851364",
  null
  
)

export default component.exports